import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import { Baseurl } from '../../constants/env';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Searchbar.scss'

const Searchbar = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [categ, setCateg] = useState([]);
    const [suggestions, setSuggestions] = useState([]);
    const [searchCategory, setSearchCat] = useState("");
    const [showCategory, setShowCategory] = useState(false);
    const categoryRef = useRef(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedItemSet, setSelectedItemSet] = useState(new Set());
    const location = useLocation()
    const navigate = useNavigate()
    async function getcategory() {
        let cat = await axios(`${Baseurl}/category`)
        setCateg(cat.data.data)
      }
        const handleSelectUser = async (prod) => {
          console.log(prod,'cc');
          
          setSelectedItems([...selectedItems, prod ])
          setSuggestions([])
          if( searchTerm == ""){
            return
          }
          setSearchTerm(prod.name)
          await navigate(`/prod/${prod._id}`)
        };

const handleSearch = async () => {
   await navigate(`/Shop?search=${searchTerm}`);
}
    const fetchSearchQuery = async () => {  
        if (searchTerm.trim() === "") {
          setSuggestions([]);
          return;
        }
        const params = new URLSearchParams();
        if(searchTerm){
          params.append('q',searchTerm)
        }
        if(searchCategory){
          params.append('c',searchCategory.id)
        }
        let result = await axios(`${Baseurl}/products?${params.toString()}`)
         setSuggestions(result?.data?.data)
      };  

        useEffect(() => {
           fetchSearchQuery()
         }, [searchTerm]);
    useEffect(() => {
        getcategory()
    }, []);       
  return (
    <>
   

         
         <div className="input-group d-flex product-search align-items-center d-none d-md-flex">

          <div>
  <input type="text" className="form-control " placeholder="Search for Products" aria-label="Text input with dropdown button"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)} />

{searchTerm ? <ul className="suggestions-list w-75 ms-2 ">
            {suggestions?.map((item,index) => {
              return! selectedItemSet.has(item._id) ? (
                <li
                  key={index} onClick={()=> handleSelectUser(item)}
                >
                  <img
                    src={`${Baseurl}/view/imageupload/${item?.img}`}
                    alt='image failed'
                  />
                  <span>{item.name}</span>
                  </li>
              ): <></>
            })}
          </ul> : <></>}</div>
          

  <button className="btn dropdown-center dropdown-toggle btn-brows-category" type="button" data-bs-toggle="dropdown" aria-expanded="false"> {searchCategory? searchCategory.name:'SELECT CATEGORY'}</button>
  <ul className="dropdown-menu dropdown-menu-end">
  {categ?.map((item) => (
      <li key={item._id}>
        <Link className="dropdown-item" href="#" onClick={(e) => { e.preventDefault(); setSearchCat({id:item._id,name:item.name}); console.log(item.name + " clicked"); }}>{item.name}</Link> {/* Or <button> */}
      </li>
    ))}
  </ul>
  <button onClick={handleSearch} className="btn btn-primary-theme btn-product-search" ><i style={{fontSize:'18px'}} class="bi bi-search"></i></button>
  </div>
    </>
  )
}

export default Searchbar

